export default __webpack_public_path__ + "static/media/24.90138061.png";